module.exports = "<div ng-if=\"$ctrl.showProgressBar\">\n  <div class=\"progress-wrapper\"></div>\n  <div class=\"progress-background\"></div>\n  <div class=\"progress-container\">\n    <div class=\"progress-title\">Processing...<span ng-if=\"$ctrl.processName\">{{ $ctrl.processName }}</span></div>\n    <div class=\"progress bar\">\n      <div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"{{ $ctrl.progress }}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:{{ $ctrl.progress }}%\"></div>\n    </div>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/solver-progress/solver-progress.html
// module id = 612
// module chunks = 0